import Vue from 'vue'
import Vuelidate from 'vuelidate'
import VueAxios from 'vue-axios'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import wb from './registerServiceWorker'
import tools from '@/utils/tools'

Vue.prototype.$workbox = wb
Vue.config.productionTip = process.env.NODE_ENV !== 'production'

// добиваем путь к api через axios
axios.defaults.baseURL = '/api'

axios.interceptors.request.use(
  // Do something before request is sent
  function (config) {
    // AUTH token для запросов, если он установлен
    const token = store.state.auth.token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    } else {
      config.headers.Authorization = null
      delete config.headers.Authorization
    }
    return config
  })

Vue.use(VueAxios, axios)
Vue.use(Vuelidate)

// Vue.filter('dateFormatMMyyyy', function (value) {
//   if (value) {
//     const date = String(value).slice(0, 10)
//     return date.slice(5, 7) + '.' + date.slice(0, 4)
//   }
// })

// TODO: надо одну функцию с форматом написать и дёргать её по необходимости
Vue.prototype.$dateFormat = (value) => {
  if (value && value.length >= 10) {
    const date = String(value).slice(0, 10)
    return date.slice(8, 10) + '.' + date.slice(5, 7) + '.' + date.slice(0, 4)
  } else return ''
}
Vue.filter('dateFormat', Vue.prototype.$dateFormat)

Vue.prototype.$dateTimeFormat = (value) => {
  if (value && value.length >= 16) {
    const date = String(value).slice(0, 16)
    return date.slice(8, 10) + '.' + date.slice(5, 7) + '.' + date.slice(0, 4) + ' ' + date.slice(11, 13) + ':' + date.slice(14, 16)
  } else return ''
}
Vue.filter('dateTimeFormat', Vue.prototype.$dateTimeFormat)

Vue.prototype.$timeFormat = (value) => {
  if (value && value.length >= 16) {
    const date = String(value).slice(0, 16)
    return date.slice(11, 13) + 'ч ' + date.slice(14, 16) + 'мин'
  } else return ''
}
Vue.filter('timeFormat', Vue.prototype.$timeFormat)

Vue.prototype.$timeFormatHHmm = (value) => {
  if (value && value.length >= 16) {
    const date = String(value).slice(0, 16)
    return date.slice(11, 13) + ':' + date.slice(14, 16)
  } else return ''
}
Vue.filter('timeFormatHHmm', Vue.prototype.$timeFormatHHmm)

Vue.filter('onlyCarNumber', function (value) {
  if (value) {
    const words = value.split('/')
    return words[0].trim()
  }
})

Vue.filter('shortName', tools.shortFIO)

// const app =
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

// меняем тему
vuetify.framework.theme.dark = store.getters['settings/dark']

axios.interceptors.response.use(null,
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  function (error) {
    // 401 - не авторизован, значит либо токена нет, либо требуется его обновление
    if (error.response.status === 401) {
      if (!store.state.auth.token) {
        router.push('/login')
        return
      }
      // токен есть, значит надо обновлять
      return new Promise((resolve, reject) => {
        axios
          .post('/auth/refreshToken')
          .then(response => {
            // обновляем токен
            store.dispatch('auth/setToken', response.data.token)
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      })
        .then(() => {
          // повторный вызов исходного запроса с новым токеном
          return new Promise((resolve, reject) => {
            axios.request(error.config).then(response => {
              resolve(response)
            }).catch((error) => {
              reject(error)
            })
          })
        })
        .catch(() => {
          // ошибка оновления токена или чё-то типа того. в любом случае это редирект на логин
          router.push('/login')
        })
    }

    // // Если с сервера получаем ошибку 500, с кодом, то это обрабатываемая ошибка
    // if (error.response.status === 500 && error.response.data && error.response.data.errorCode) {
    //   if ([
    //     // ошибка блокировки
    //     1,
    //   ].some(x => x === error.response.data.errorCode)) {
    //     app.$notify('error', error.response.data.message)
    //   }
    // }

    // прокидываем ошибку, чтобы не отработал then
    return new Promise((resolve, reject) => { reject(error) })
  })
